import { render, staticRenderFns } from "./DocumentSidebarStorageView.vue?vue&type=template&id=6c22bdf6"
import script from "./DocumentSidebarStorageView.vue?vue&type=script&lang=js"
export * from "./DocumentSidebarStorageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports